import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import {
  transformVirtualTenantRecord,
  VirtualTenantForm,
} from "./VirtualTenantForm";
import { useNotification } from "../../../common/hooks/useNotification";

interface IVirtualTenantCreateProps {}

export const VirtualTenantEdit = (props: IVirtualTenantCreateProps) => {
  const notify = useNotification(props, "editSuccess");
  return (
    <Edit
      {...props}
      actions={<EditActions />}
      mutationMode="pessimistic"
      onSuccess={notify}
      transform={transformVirtualTenantRecord}
      title="Edit a virtual customer"
    >
      <VirtualTenantForm isEdit />
    </Edit>
  );
};
